import { Component, OnInit } from "@angular/core";
import { FieldType } from "@ngx-formly/core";
import { faSortDown } from "@fortawesome/free-solid-svg-icons/faSortDown";
import { faSortUp } from "@fortawesome/free-solid-svg-icons/faSortUp";

@Component({
	selector: "formly-field-input",
	template: `
		<div class="custom-control custom-checkbox">
			<ng-container *ngIf="to.placeholder.length > 100">
				<button
					type="button"
					class="col-12 btn btn-primary"
					(click)="isCollapsed = !isCollapsed; toggleSortIcon()"
					[attr.aria-expanded]="!isCollapsed"
					aria-controls="collapseBasic"
				>
					{{ "ed_pr_" + field.key | translate }}
					<fa-icon [ngClass]="iconClass()" [icon]="faSort"></fa-icon>
				</button>
				<div
					id="regolamento"
					[collapse]="isCollapsed"
					class="card card-block card-header"
				>
					<pre class="pre-fix" style="font-weight: 400" [ngClass]="smallFont()">
					{{ to.placeholder }}
				</pre
					>
					<input
						type="checkbox"
						class="custom-control-input"
						[formControl]="formControl"
						[formlyAttributes]="field"
					/>
					<label
						class="custom-control-label fix-custom-checkbox"
						for="{{ field.id }}"
					>
					Accetto <span *ngIf="to.required">*</span></label
					>
				</div>
			</ng-container>
			<ng-container *ngIf="to.placeholder.length < 100">
				<pre
					*ngIf="to.placeholder"
					class="pre-fix"
					style="font-weight: 400"
					[ngClass]="smallFont()"
				>
					{{ to.placeholder }}
				</pre>
				<input
					type="checkbox"
					class="custom-control-input"
					[formControl]="formControl"
					[formlyAttributes]="field"
				/>
				<label
					class="custom-control-label fix-custom-checkbox"
					for="{{ field.id }}"
				>
				Accetto <span *ngIf="to.required">*</span></label
				>
			</ng-container>
		</div>
	`
})
export class FormlyFieldInput extends FieldType implements OnInit {
	constructor() {
		super();
	}

	isCollapsed = true;

	faSort = faSortDown;

	ngOnInit() {}

	toggleSortIcon() {
		this.faSort = this.faSort == faSortDown ? faSortUp : faSortDown;
	}

	iconClass() {
		return {
			"sort-down": this.faSort == faSortDown,
			"sort-up": this.faSort != faSortDown
		};
	}

	smallFont() {
		return { "small-font": this.to.placeholder.length > 100 };
	}
}

@Component({
	selector: "sanremo-control-checkbox",
	template: `
		<div class="custom-control custom-checkbox">
			<input
				type="checkbox"
				class="custom-control-input"
				[formControl]="formControl"
				[formlyAttributes]="field"
			/>
			<label *ngIf="to.label"
				class="custom-control-label fix-custom-checkbox"
				for="{{ field.id }}">{{to.label}}<span *ngIf="to.required">*</span></label
			>
		</div>
	`
})
export class SanremoCheckboxFieldInput extends FieldType implements OnInit {}


@Component({
	selector: 'sanremo-input-lite',
	template: `
	<div class="form-group mb-1">
	<label>{{ to.label }} {{ to.required ? "*" : "" }}</label>

	<div class="input-group">
		<input type="text" class="form-control" 
		[required]="isRequired(to.required)"
		placeholder="{{ to.placeholder }}" 
		[formControl]="formControl"
		[formlyAttributes]="field"
		[class.is-invalid]="showError"
		onlyLatinAllowed/>
	</div>
	<div *ngIf="formControl.touched && formControl.invalid">
		<small class="text-danger" *ngIf='formControl.errors.onlyLatinAllowed'>{{formControl.errors.onlyLatinAllowed}}</small>
	</div>		
</div>
 `,
})
export class SanremoFieldInputText extends FieldType implements OnInit {

	constructor() {
		super();
	}

	isRequired(value){
		if (value != undefined)
		return value;
	else
		return false;
	}
}

@Component({
	selector: 'sanremo-area-lite',
	template: `
	<div class="form-group mb-1">
	<label>{{ to.label }} {{ to.required ? "*" : "" }}</label>

	<div class="input-group">
		<textarea type="text" class="form-control" 
		[required]="isRequired(to.required)"
		placeholder="{{ to.placeholder }}" 
		[formControl]="formControl"
		[formlyAttributes]="field"
		[class.is-invalid]="showError"
		[cols]="to.cols"
		[rows]="to.rows" class="form-control" 
		[disabled]="to.disabled" onlyLatinAllowed>
		</textarea>
	</div>
	<div *ngIf="formControl.touched && formControl.invalid">
		<small class="text-danger" *ngIf='formControl.errors.onlyLatinAllowed'>{{formControl.errors.onlyLatinAllowed}}</small>
	</div>		
</div>
 `,
})
export class SanremoFieldTextarea extends FieldType implements OnInit {

	constructor() {
		super();
	}

	isRequired(value){
		if (value != undefined)
		return value;
	else
		return false;
	}
}